import request from '@/router/axios'
import env from '../../config/env'

/**
 * 获取banner列表
 */
export const footerBannerPage = (data) => {
  return request({
    // url: 'http://192.168.31.56:37579/advertising/banner/page',
    url: `${env.ferryUrl}/advertising/banner/page`,
    method: 'post',
    data
  })
}

/**
 * 修改banner
 */
export const editFooterBanner = (data) => {
  return request({
    url: `${env.ferryUrl}/advertising/banner/edit`,
    method: 'post',
    data
  })
}

/**
 * 修改banner状态
 */
export const changeBannerStatus = (data) => {
  return request({
    url: `${env.ferryUrl}/advertising/banner/changeStatus`,
    method: 'post',
    data
  })
}

/**
 * 获取banner详情
 */
export const getBannerDetail = (id) => {
  return request({
    url: `${env.ferryUrl}/advertising/banner/detail/${id}`
  })
}
